import React from 'react';

export default (
    <svg
        className="svg-purple-checkmark"
        width="8px"
        height="6px"
        viewBox="0 0 8 6"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                className="check-purple"
                transform="translate(-447.000000, -422.000000)"
                fill="#B394F2"
                stroke="#B394F2"
                strokeWidth="0.833333333"
            >
                <g transform="translate(447.000000, 423.000000)">
                    <path
                        d="M6.93762218,0.0421456627 L2.64874962,4.05306179 L0.662377815,2.19549081 C0.602287187,2.13929659 0.5051586,2.13929659 0.445067971,2.19549081 C0.384977343,2.25168503 0.384977343,2.34251558 0.445067971,2.39870979 L2.5400947,4.35789027 C2.56883369,4.38476576 2.60786955,4.4 2.64874962,4.4 C2.689476,4.4 2.72851186,4.38476576 2.75740454,4.35789027 L7.15493203,0.245364647 C7.21502266,0.18917043 7.21502266,0.0983398796 7.15493203,0.0421456627 C7.0948414,-0.0140485542 6.99771281,-0.0140485542 6.93762218,0.0421456627"
                        id="Fill-228"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);
